import React from 'react';
import PropTypes from 'prop-types';
import {withStyles, TableRow, TableCell, Typography} from "@material-ui/core";
import {useInView} from "react-intersection-observer";
import moment from 'moment-timezone';

import RentingRow from './RentingRow';
import {displayDateFormat} from "../../../../../utils/staticData";
import {themeTypeToBool} from "../../../../../utils/helpers";

const useStyles = theme => ({
    cell: {
        background: themeTypeToBool(theme.palette.type) ? "white" : "#737393",
        textAlign: "center",
    },
    dateRowHeight: {height: 35},
    typography: {
        fontWeight: "bold"
    }
});

const CustomCell = withStyles(theme => ({
    root: {
        textAlign: "center",
        padding: theme.spacing(1),
    }
}))(props => <TableCell colSpan={9} {...props}/>);

const DateRow = props => {
    const {classes, data, carId, onDialogOpenCallback, onDateChangeCallback} = props;

    const [observe, inView] = useInView();

    return (
        <React.Fragment>
            <TableRow ref={observe} className={classes.dateRowHeight}>
                {inView ? <CustomCell
                    className={classes.cell}
                >
                    <Typography
                        variant="body2"
                        className={classes.typography}
                    >
                        {moment.unix(data.data_od).format(displayDateFormat)}
                    </Typography>
                </CustomCell> : null}
            </TableRow>
            <RentingRow
                key={data.wynajem_id}
                data={data}
                carId={carId}
                onDialogOpenCallback={(rent_id, type) => onDialogOpenCallback(rent_id, type)}
                onDateChangeCallback={onDateChangeCallback}/>
        </React.Fragment>
    );
};

DateRow.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    carId: PropTypes.number,
    onDialogOpenCallback: PropTypes.func,
    onDateChangeCallback: PropTypes.func,
};

export default withStyles(useStyles)(DateRow);